"use strict";

exports.onRouteUpdate = function () {
  // Don't track while developing.
  if (process.env.NODE_ENV === "production" && typeof FB === "function") {
    window.FB.AppEvents.logPageView();
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-facebook-analytics/gatsby-browser.js
// module id = 467
// module chunks = 231608221292675